import qs from "qs";

import { axiosWithAuth } from "helpers";
import { getTerminalSolutionBody } from "mappers";

export const terminalSolutionService = {
	getTerminalSolutions,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getTerminalSolutions({ page, filters, sortBy }) {
	const body = getTerminalSolutionBody({
		page,
		filters,
		sortBy,
		PAGE_SIZE,
	});
	const options = {
		url: `${API_URL}/api/terminal_solutions`,
		params: body,
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	};

	return axiosWithAuth(options);
}
